import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-home-hero-banner-v2',
    templateUrl: './block-home-hero-banner-v2.component.html',
    styleUrl: './block-home-hero-banner-v2.component.scss',
    standalone: false,
})
export class BlockHomeHeroBannerV2Component extends BlockAbstractComponent implements OnInit {
    hasHeading!: boolean;

    override ngOnInit() {
        super.ngOnInit();

        this.hasHeading = this.block.data.heading || this.block.data.headingTop || this.block.data.headingBottom;
    }

    getBackground() {
        if (this.block.data.useBgImage) {
            return `url(${this.block.data.image})`;
        }

        switch (this.block.data.bgFillColor) {
            case 'white':
                return 'white';

            case 'primary':
                return 'var(--color-primary)';

            case 'secondary':
                return 'var(--color-secondary)';

            case 'gradient':
                return `linear-gradient(${this.block.data.bgLinearGradient})`;

            default:
                return this.block.data.bgFillColor || 'white';
        }
    }
}
